import 'aos/dist/aos.css';
import Aos from 'aos'
import { forwardRef, Ref, useEffect } from 'react';
import { Paper, Typography, useMediaQuery, useTheme } from '@mui/material';

const QueEsAndesGenomics = forwardRef((props, ref : Ref<HTMLDivElement>) => {
    useEffect(() => {
        Aos.init({ duration: 500 })
    }, [])

    const theme = useTheme()
    const isSmall = !useMediaQuery(theme.breakpoints.up('md'))
    return (
        <div ref={ref} data-aos='zoom-in-up' style={{ textAlign: 'left', background: '#282c34' }}>
            <div className='QueEsAgBG' style={{
                padding: (isSmall) ? '1rem' : '3rem'
            }}>
                <Paper square={false} elevation={4} style={{
                    position: "relative", zIndex: 99, transform: "translateY(-50%)", backgroundColor: "rgb(40 44 52)"
                }}>
                    <div className='flex-row-a'>
                        <div style={{
                            display: "flex", flexDirection: "column", padding: "1rem"
                        }}>
                            <Typography style={{ fontWeight: '600' }} variant='h5' component={'h2'}>
                                ¿Qué hacemos en AndesGenomics?
                            </Typography>
                            <Typography variant='subtitle1' style={{ marginBottom: '1rem' }}>
                                Ofrecemos asesoramiento genético para diversos casos
                            </Typography>
                            <Typography style={{ marginBottom: '1rem' }}>
                                Aseguramos que los pacientes reciban la mejor disponibilidad y atencion de sus necesidades
                            </Typography>
                            <Typography>
                                Nos especializamos en casos especiales para brindar el mejor apoyo y cubrir las necesidades especificas
                            </Typography>
                        </div>

                        <div data-aos='fade-right' data-aos-delay={500} className='QueEsAGImg1'></div>

                    </div>
                </Paper>
            </div>
        </div>);
});

export { QueEsAndesGenomics }